import {HStack, Pressable} from "@hosttools/frontend/components";
import type React from "react";
import {memo} from "react";
import {Link} from "react-router-dom";

import Text from "../Text";

export type Props = {
    children: React.ReactNode;
    path?: string;
    active?: boolean;
    icon?: React.ReactNode;
    testID?: string;
    onClick?: () => void;
};

const MenuItem: React.FC<Props> = ({children, path, active, icon, testID, onClick}) => {
    const childNode: React.ReactNode = (
        <HStack
            className={`items-center justify-between rounded-md p-3 lg:p-2 ${
                active ? "bg-blueGray-100" : ""
            }`}
        >
            {typeof children === "string" ? (
                <Text color={active ? "blue.600" : undefined} variant="sm">
                    {children}
                </Text>
            ) : (
                children
            )}
            {icon}
        </HStack>
    );
    return (
        <Pressable
            className="rounded-md hover:bg-blueGray-100 focus:bg-blueGray-100"
            testID={testID}
            onPress={onClick}
        >
            {path ? <Link to={path}>{childNode}</Link> : childNode}
        </Pressable>
    );
};

export default memo(MenuItem);
